(() => {
  angular
    .module('app.settings')
    .controller('AdformLogController', AdformLog);

  AdformLog.$inject = [
    '$scope',
    '$filter',
    '$timeout',
    '$location',
  ];

  function AdformLog(
    $scope,
    $filter,
    $timeout,
    $location,
  ) {

    const dateShort = $filter('dateShort');
    const dateTimeShort = $filter('dateTimeShort');
    const dateLong = $filter('dateLong');
    const end = new Date();
    const start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 7);
    const getPeriodLabel = () => `${dateLong(vm.periodStart)} - ${dateLong(vm.periodEnd)}`;

    const vm = this;
    vm.periodStart = start;
    vm.periodEnd = end;
    vm.selectedPeriod = getPeriodLabel();

    vm.nextToken = undefined;
    vm.adFormCampaignId = undefined;
    vm.adFormLineItemId = undefined;
    vm.adFormTagId = undefined;
    vm.limit = 100;

    vm.items = [];
    vm.recordsLoading = true;
    let abortController = '';

    const fetchRecords = showMore => {
      const params = {
        limit: vm.limit,
        tagId: vm.adFormTagId,
        endTime: vm.periodEnd && `${dateShort(vm.periodEnd)} 23:59:59`,
        startTime: vm.periodStart && `${dateShort(vm.periodStart)} 00:00:00`,
        campaignId: vm.adFormCampaignId,
        lineItemId: vm.adFormLineItemId,
        nextToken: showMore ? vm.nextToken: undefined,
      };

      const transformItem = item => ({
        time: dateTimeShort(item.time),
        message: item.message || item.additionalInfo?.errorMessage,
      });

      abortController = new AbortController();
      fetch(`log/adform-records?${new URLSearchParams(JSON.parse(JSON.stringify(params)))}`, {
        method: 'get',
        signal: abortController.signal,
      })
        .then(response => response.json())
        .then(({ records, nextToken }) => {
          if (showMore) {
            vm.items = [
              ...vm.items,
              ...records.map(item => ({
                ...item,
                ...transformItem(item),
              })),
            ];
          } else {
            vm.items = records.map(item => ({
              ...item,
              ...transformItem(item),
            }));
          }

          vm.nextToken = nextToken;
        })
        .finally(() => {
          vm.recordsLoading = false;
          vm.recordsMoreLoading = false;
          $scope.$apply();
        });
    };
    fetchRecords();



    /* ************************************************************* */
    /* ************************* Date picker *********************** */
    /* ************************************************************* */
    $timeout(() => {
      initDatepicker();
    }, 250);

    function initDatepicker() {
      const picker = $('#datePickerLog');
      picker.daterangepicker({
        startDate: start,
        endDate: end,
        weekRanges: false,
        showWeekNumbers: true,
        locale: {
          firstDay: 1,
        },
        dateLimit: {
          months: 3,
        },
        format: 'yyyy-MM-dd',
      });

      const daterangepicker = $('.daterangepicker');
      daterangepicker.addClass('daterangepicker-static');
      picker.append(daterangepicker);

      picker.find('.calendar').click(() => {
        const data = picker.data('daterangepicker');
        vm.periodStart = data.startDate;
        vm.periodEnd = data.endDate;
        vm.selectedPeriod = getPeriodLabel();
      });
    }

    vm.toggleDatePicker = () => {
      vm.showDatePicker = !vm.showDatePicker;
    };



    /* ************************************************************* */
    /* ************************** Actions ************************** */
    /* ************************************************************* */
    vm.handleUpdateFilter = () => {
      if (abortController) {
        abortController.abort();
      }

      fetchRecords();

      vm.updateThrottling = true;
      $timeout(() => {
        vm.updateThrottling = false;
        vm.recordsLoading = true;
      }, 1000);
    };

    vm.handleShowMore = () => {
      vm.recordsMoreLoading = true;
      fetchRecords(true);
    };

    vm.handleBackToIntegrations = () => {
      $location.path('/apiintegrations');
    };

    vm.handleExportToCsv = () => {
      console.log('handleExportToCsv');
    };

    vm.clearPeriod = event => {
      event.stopPropagation();

      vm.periodStart = undefined;
      vm.periodEnd = undefined;
      vm.selectedPeriod = '';
    };

    vm.clearField = field => {
      vm[field] = '';
    };
  }
})();
